export default {
// 分页查询供应商付款列表
  selectYcSupplierPriceByPage: '/ygsjzs/ycnSupplierPrice/selectYcnSupplierPriceByPage',
  // 查询供应商付款详情
  selectYcSupplierPriceByPriceId: '/ygsjzs/ycnSupplierPrice/selectYcnSupplierPriceByPriceId',
  // 物理删除供应商付款
  deleteDataYcSupplierPrice: '/ygsjzs/ycnSupplierPrice/deleteDataYcnSupplierPrice',
  // 修改供应商付款
  updateYcSupplierPrice: '/ygsjzs/ycnSupplierPrice/updateYcnSupplierPrice',
  // 新增供应商付款
  insertYcSupplierPrice: '/ygsjzs/ycnSupplierPrice/insertYcnSupplierPrice'

}
